import { DateInput, Field, NumericInput, TextOutput, TimeInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import {
  IWithWorksheetInjectedProps,
  WorksheetGridFieldSection,
  WorksheetRecordGrid,
} from 'Components/Worksheets/Core';
import { TareId } from 'Components/Worksheets/Core/Fields/TareId';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { VolumeDeterminationMethod } from 'Components/Worksheets/MoistureContentWorksheet/BsEn/types';
import { valueOrDefault } from 'Lib/Any';
import { DateTimeDataFormat } from 'Lib/Format';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';

let BsEnMeasurementsMultiTraysGridSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const showTimeInOven = useSelector(
    pipe(createDryMassEntryOptionSelector(createWorksheetSelector!), (v) => v !== 'Never')
  );

  const lightweightAggregate = useSelector(
    pipe(createWorksheetSelector!('Preparation.LightweightAggregate'), valueOrDefault(false))
  );

  const isBulkDensity = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.VolumeDeterminationMethod'),
      (p) => p === VolumeDeterminationMethod.BulkDensity
    )
  );

  return (
    <>
      <WorksheetGridFieldSection name="DryingTrays">
        <WorksheetRecordGrid
          name="DryingTrays"
          orientation="horizontal"
          scrollLinkId="mddCompaction"
          rowHeaderWidth={200}
          recordProps={{
            width: 130,
            enforceAtLeastOneRecord: true,
            removeConfirm: {
              confirm: true,
              confirmTitle: 'Delete drying tray',
              confirmText: 'Are you sure you want to delete the drying tray? Data cannot be recovered.',
              confirmButtonText: 'Delete',
            },
          }}
          fieldSet={[
            { name: 'ContainerLabel', component: <TareId inGrid /> }, //maxLength:20
            { name: 'ContainerMass', component: <Field input={<NumericInput />} /> },
            {
              name: 'WetSoilAndContainerMass',
              component: <Field input={<NumericInput />} />,
              label: 'Tare & Wet Mass (g)', // shortened
            },
            {
              name: 'DateTimePlacedInOvenLocal',
              component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
              label: 'Date in Oven',
              hidden: !showTimeInOven,
            },
            {
              name: 'DateTimePlacedInOvenLocal',
              component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
              label: 'Time in Oven',
              hidden: !showTimeInOven,
            },
          ]}
        />
      </WorksheetGridFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Measurements.TotalWetMass" label="Total Material Wet Mass" />
        <Field input={<TextOutput />} name="Measurements.Volume" visible={lightweightAggregate && isBulkDensity} />
      </ListFieldSection>
    </>
  );
};
BsEnMeasurementsMultiTraysGridSection = withInjectedProps(BsEnMeasurementsMultiTraysGridSection);

export { BsEnMeasurementsMultiTraysGridSection };
